if($('.type-detail').length){
        if ($('.p-detail>.p-detail-inner>form>.product-top>div:not(.col-lg-6) .flag-konfigurator-2').length) {
     
if($('.admin-logged').length){

    let adminInfo = '<div class="specialKeys"><p>Tento text vidí jenom přihlášený admin.<br>' +
    'Obrázky ukládejte do složky <code>"priplatky"</code> ve správci souborů. ' +
    'V této složce vytvořte podsložky dle klíče.</p>';

    adminInfo += '<table class="mapTable" border="1" cellspacing="0" cellpadding="4">';
    adminInfo += '<thead><tr><th>Sekce</th><th>Parametr</th><th>Složka</th><th>Option hodnota</th><th>Option text</th></tr></thead><tbody>';

    $('table.detail-parameters select').each(function () {

        const $select   = $(this);
        const paramId   = $select.data('parameter-id');
        const paramName = $select.data('parameter-name');

        let foundSection = '(není ve stromu)';

        // 🔥 HLEDÁNÍ VE STROMU
        $.each(productTree, function(sectionName, config){

            function findInTree(node){
                if(node.param === paramName){
                    foundSection = sectionName;
                }
                if(node.children){
                    Object.values(node.children).forEach(child=>{
                        findInTree(child);
                    });
                }
            }

            findInTree(config);

        });

        const folder = cleanParamName(paramName);

        $select.find('option').each(function () {

            const $option = $(this);
            const val = $option.val();

            if ($.isNumeric(val)) {

                const txt = $option.text();

                adminInfo += '<tr>' +
                    '<td><strong>' + foundSection + '</strong></td>' +
                    '<td>' + paramName + '</td>' +
                    '<td><code>' + folder + '</code></td>' +
                    '<td>' + val + '</td>' +
                    '<td><code>' + txt + '</code></td>' +
                    '</tr>';
            }

        });

    });

    adminInfo += '</tbody></table></div>';
    $('.product-top').append(adminInfo);
}


    // 🔽 SECTIONS
const $targetWrapper = $('<div class="surcharge-sections"></div>');
const sectionMap = {};

$.each(productTree, function (sectionName, config) {

    const $section = $('<div class="surcharge-section ' 
        + cleanParamName(sectionName) 
        + '" data-totalSectionPrice="0"></div>');

    $section.append('<h2>' + sectionName + '</h2>');

    const $group = $('<div class="custom-surcharge-group"></div>');

    if (config.customText) {
        $group.append(
            '<div class="customSectionText">' + config.customText + '</div>'
        );
    }

    $section.append($group);

    sectionMap[sectionName] = $section;
    $targetWrapper.append($section);

});

$('table.detail-parameters select').each(function () {

    const $select = $(this);
    const paramId = $select.data('parameter-id');
    const paramName = $select.data('parameter-name');

    let foundSection = null;

    // 🔥 TADY JE KROK 3
    $.each(productTree, function(sectionName, config){

        function findInTree(node){
            if(node.param === paramName){
                foundSection = sectionMap[sectionName];
            }
            if(node.children){
                Object.values(node.children).forEach(child=>{
                    findInTree(child);
                });
            }
        }

        findInTree(config);

    });

   if (!foundSection) {
    console.warn("Parametr není ve stromu:", paramName);
    return;
}
  

        let $groupWrap = foundSection.find('.custom-surcharge-group');
        if ($groupWrap.length === 0) {
            $groupWrap = $('<div class="custom-surcharge-group"></div>');
            foundSection.append($groupWrap);
        }

        //const $customWrap = $('<div class="custom-surcharge"></div>');
        const $customWrap = $('<div class="custom-surcharge" data-param-name="'+paramName+'"></div>');
        const $wrap = $('<div class="custom-surcharge-wrap" data-param-id="' + paramId + '"></div>');

        $select.find('option').each(function () {
            const $option = $(this);
            const val = $option.val();
            if ($.isNumeric(val)) {
                let price = 0;
                const txt = $option.text();
                const parts = txt.split('+');
                if (parts[1]) {
                    price = parseFloat(parts[1].replace(/[^\d]/g, '')) || 0;
                }

                const imageUrl = '/user/documents/upload/priplatky/' + cleanParamName(paramName) + '/' + val + '.jpg';

                const $surcharge = $('<div class="surcharge" data-price="' + price + '" data-value="' + val + '" data-parameter-id="' + paramId + '" data-param-val="' + paramId + '-' + val + '">' +
                    '<div class="image"><img src="' + imageUrl + '" loading="eager"></div>' +
                    '<div class="text"><span class="title">' + parts[0] + '</span>' + (parts[1] ? '<span class="prize">+' + parts[1] + '</span>' : '') + '</div>' +
                    '</div>');

                $wrap.append($surcharge);
            }
        });

        // zjisti kolik parametrů má sekce
      // zjisti kolik parametrů má sekce ze stromu
const sectionName = Object.keys(sectionMap).find(k => sectionMap[k].is(foundSection));

let totalParamsInSection = 0;

function countParams(node){
    if(node.param) totalParamsInSection++;
    if(node.children){
        Object.values(node.children).forEach(child=>{
            countParams(child);
        });
    }
}

countParams(productTree[sectionName]);

if (totalParamsInSection === 1) {

    foundSection.addClass('singleSection');

} else {

   // let h3Html = '<div class="h3">';
   // let h3Html = '<div class="h3">' + paramName + '<span class="price"></span></div>';
  //  h3Html += paramName + '<span class="price"></span></div>';
const level = getParamLevel(paramName);
let levelClass = level !== null ? ' h3-level-' + level : '';

let h3Html = '<div class="h3' + levelClass + '">';

if (paramIcons[paramName]) {
    h3Html += '<img class="h3-icon" src="' + paramIcons[paramName] + '" alt="' + paramName + '"> ';
}

h3Html += paramName + '<span class="price"></span></div>';
    $customWrap.append(h3Html);
const sectionConfig = productTree[sectionName];

if (sectionConfig.openRoot && paramName === sectionConfig.param) {

    $customWrap.addClass('active');
    $wrap.css('display','flex').addClass('open');

    if (sectionConfig.rootOrder !== undefined) {
        $customWrap.css('order', sectionConfig.rootOrder);
    }

} else {
    $wrap.hide();
}
}

$customWrap.append($wrap);
$groupWrap.append($customWrap);
$select.closest('tr').hide();
        
    });


    $('.p-info-wrapper').append($targetWrapper);

initProductTree(productTree);





}

$('.surcharge-section').each(function () {
    if ($(this).find('.custom-surcharge').length === 0) {
        $(this).remove();
    }
});
let style = $('.availability-value .availability-label').attr('style');
style = style ? style.trim() : '#fff';

        $('.p-info-wrapper').append('<div class="availDelivery"><div class="left" style="'+style+'"></div></div><div class="codeAndWarranty"></div><div class="customCart"></div>');

    if($('.p-thumbnails-inner').length){
        $('.p-image').addClass('haveThumb');
        $('.p-image-wrapper .p-image').append('<span class="imageArrow arrow-prev"></span><span class="imageArrow arrow-next"></span>');
    }

    $('.p-info-wrapper').append($('.breadcrumbs').clone());
    $('.p-info-wrapper').append($('.usp').clone());
    $('p[data-testid="productCardDescr"] a').text('Zobrazit detailní popis');

    $('.extended-description .detail-parameters th').each(function(){
        if($(this).text().trim() === 'Odhadovaná doba instalace:'){
            var time = $(this).closest('tr').find('td').text().trim()
            $('.p-info-wrapper').append('<div class="instalationTime"><p>Odhadovaná doba instalace: <span class="time">'+time+'</span> <span class="work">'+getDifficulty(parseFloat(time))+' instalace</span></p></div>')
        }
        if($(this).text().trim() === 'Záruka:'){
            $('.codeAndWarranty').append('<span class="warranty">Záruka: <strong>'+$('.extended-description .detail-parameters tr:contains("Záruka:")').closest('tr').find('td').text().trim()+'</strong></span>')
        }
    });
    $('.p-info-wrapper').append('<div class="needHelping"><div class="image"><img src="/user/documents/upload/sablona-nemazat/helpbig.png?1" alt="Potřebujete poradit?"></div><div class="right"><div class="h2">Potřebujete poradit?</div><p>Ozvěte se, rádi vám pomůžeme</p></div></div>')
    $('.needHelping .right').append($('footer#footer .contact-box li span.tel').clone());
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'));
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone());
    $('.p-info-wrapper').append($('.p-detail-info').clone());
    $('.availability-value').prepend('<i style="background-'+style+'"></i>')
    $('.availDelivery .left').append($('.availability-value'));
    if($('.delivery-time').length){
        $('.delivery-time>span').prepend('nejpozději ').append(' u Vás')
        $('.delivery-time').closest('tr').hide();
        $('.availDelivery .left').append('<div class="availtime">'+$('.delivery-time').html()+'</div>')
    }
    $('.availDelivery').append($('.shipping-options'));
    
    $('.customCart').append($('.p-final-price-wrapper'));
    $('.customCart').append($('.add-to-cart'));
    $('.codeAndWarranty').append($('.p-info-wrapper .p-code'));
    $('.extended-description').append($('footer#footer .detailNeedHelp'));
    
}

$('body').on('click', '.surcharge-section > h2', function () {
    const $section = $(this).closest('.surcharge-section');
    $section.toggleClass('openGroup');

    const $group = $section.find('.custom-surcharge-group');
    $group.toggleClass('open');
});     

$('html').on('click', '.surcharge-section .h3', function(){

    const $custom = $(this).closest('.custom-surcharge');
    const $wrap   = $custom.children('.custom-surcharge-wrap');

    $custom.toggleClass('active');

    if ($wrap.is(':visible')) {
        $wrap.slideUp(200).removeClass('open');
    } else {
        $wrap .css('display','flex')
  .hide()
  .slideDown(200).addClass('open');
    }

});


    


$(document).on('click', '.custom-surcharge-wrap .surcharge', function(){
    const $clicked = $(this);
    const variantData = $clicked.data('value');
    const variantParameterId = $clicked.data('parameter-id');
    const $wrap = $clicked.closest('.custom-surcharge-wrap');
    const paramName = $("select[data-parameter-id='"+variantParameterId+"']").data('parameter-name');
    const $section = $clicked.closest('.surcharge-section');
    const sectionName = $section.find('h2').text().trim();
 const $param = $(this).closest('.custom-surcharge');

    setTimeout(function(){
        clearValidationState($param);
    }, 50);


    // --- původní tvůj kód ---
    $("select[data-parameter-id='"+variantParameterId+"'] option")
        .filter(function (){return $(this).attr('value') == variantData })
        .change()
        .prop("selected", true);

    var selector = '.variant-list .hidden-split-parameter, .surcharge-list .split-parameter';
    var $splitParameters = $(selector);
    $splitParameters.trigger('change');

    $wrap.find(".surcharge:not([data-value='"+variantData+"'])").removeClass("active");
    $clicked.addClass("active");    

    $clicked.closest('.custom-surcharge').find('.h3 .price')
        .html('+ '+Number($clicked.attr('data-price')).ShoptetFormatAsCurrency());

    $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));

    $('.custom-surcharge-wrap .surcharge').each(function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
        const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");    
        if (unavailable === true) {
            $(this).addClass("unavailable").removeClass("active");
        }
        else{
            $(this).removeClass("unavailable");
        } 
    });

    let total = 0;
    $section.find('.surcharge.active').each(function () {
        const p = Number($(this).data('price')) || 0;
        total += p;
    });
    $section.attr('data-totalsectionprice', total);

    $('.priceAccesories').html(Number($('.2-pokracujte-vyberem-prislusenstvi').attr('data-totalsectionprice')).ShoptetFormatAsCurrency());
    $('.priceAccesoriesOrnaments').html(Number($('.3-text-ornament-na-nahrobku').attr('data-totalsectionprice')).ShoptetFormatAsCurrency());
    $('.priceAccesoriesService').html(Number($('.4-doplnkove-sluzby').attr('data-totalsectionprice')).ShoptetFormatAsCurrency());
    $('.priceTotalWithAll').html($('.p-final-price-wrapper .price-final-holder').html());
});

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-surcharge-wrap .surcharge').removeClass('unavailable')
    })
    $(document).ready(function(){

        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.surcharge");
            if ($variants.length === 1) {
              $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.surcharge[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }

        // 🔥 Stromové vnoření parametrů pod parent



    });


function cleanParamName(name) {
    return name.toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getDifficulty(minutes) {
    for (let r of ranges) {
        if (minutes >= r.min && minutes <= r.max) {
            return r.label;
        }
    }
    return 'Neznámá';
}


    $('body').on('click', '.arrow-prev, .arrow-next', function () {
        var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
        var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
        var isNext = $(this).hasClass('arrow-next');
        var totalThumbnails = thumbnails.length;
        var currentIndex = thumbnails.index(highlightedThumbnail);
        thumbnails.removeClass('highlighted');
        if (highlightedThumbnail.length === 0) {
            highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
        } else {
            currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
            highlightedThumbnail = thumbnails.eq(currentIndex);
        }
        highlightedThumbnail.addClass('highlighted');
        toggle360ImageVisibility(highlightedThumbnail);
        setTimeout(function () {
            updateMainImage(highlightedThumbnail);
        }, 10);
    });

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
    }
    function toggle360ImageVisibility(highlightedThumbnail) {
        var is360Image = highlightedThumbnail.hasClass('show360image');

        if (is360Image) {
            $('.image360').show();
            $('.p-image').hide();
        } else {
            $('.image360').hide();
            $('.p-image').show();
        }
    }
   

function initProductTree(tree){

function hideBranch(node){
    if(!node.children) return;
    Object.values(node.children).forEach(child=>{
        if(child.param){
            $('.custom-surcharge[data-param-name="'+child.param+'"]').hide();
        }
        hideBranch(child);
    });
}

function showBranch(node){
    if(!node.children) return;
    Object.values(node.children).forEach(child=>{
        if(child.param){
            $('.custom-surcharge[data-param-name="'+child.param+'"]').slideDown(200);
        }
        showBranch(child);
    });
}

Object.keys(tree).forEach(sectionName=>{

    const root = tree[sectionName];
    if(!root.param || !root.children) return;

    const $rootWrap = $('.custom-surcharge[data-param-name="'+root.param+'"]');
    if(!$rootWrap.length) return;

    // ✅ SKRYJ JEN DRUHOU ÚROVEŇ (ne root)
    Object.values(root.children).forEach(child=>{
        if(child.children){
            Object.values(child.children).forEach(grandChild=>{
                if(grandChild.param){
                    $('.custom-surcharge[data-param-name="'+grandChild.param+'"]').hide();
                }
            });
        }
    });

    $(document).on(
        'click',
        '.custom-surcharge[data-param-name="'+root.param+'"] .surcharge',
        function(){

            const selected = $(this).find('.title').text().trim();

            // skryj všechny větve pod rootem
            hideBranch(root);

            // zobraz jen vybranou
            if(root.children && root.children[selected]){
                showBranch(root.children[selected]);
            }

        }
    );

});

}


document.addEventListener('dkLabNoteAttachmentLoaded', function() {

    Object.keys(productTree).forEach(sectionName => {

        const cfg = productTree[sectionName];

        if(cfg.appendTo){

            const $section = $('.surcharge-section.' + cleanParamName(sectionName));
            const $el = $(cfg.appendTo);

            if($section.length && $el.length){
                $section.find('.custom-surcharge-group').prepend($el);
            }

        }

    });

});

function getParamLevel(paramName) {

    let levelFound = null;

    function search(node, level) {

        if (node.param === paramName) {
            levelFound = level;
        }

        if (node.children) {
            Object.values(node.children).forEach(child => {
                search(child, level + 1);
            });
        }
    }

    Object.values(productTree).forEach(root => {
        search(root, 0);
    });

    return levelFound;
}

function validateProductTree() {

    let isValid = true;
    let firstError = null;

    // nejdřív smaž staré chyby
    $('.validation-error').removeClass('validation-error');
    $('.surcharge-section').removeClass('section-error');

    $('.custom-surcharge:visible').each(function(){

        const $param   = $(this);
        const $section = $param.closest('.surcharge-section');

        let paramValid = true;

        // klasické varianty
        const $options = $param.find('.surcharge');
        if ($options.length) {
            if ($options.filter('.active').length === 0) {
                paramValid = false;
            }
        }

        // textarea
        const $textarea = $param.find('textarea');
        if ($textarea.length) {
            if ($textarea.val().trim() === '') {
                paramValid = false;
            }
        }

        // file
        const $file = $param.find('input[type="file"]');
        if ($file.length) {
            if (!$file.val()) {
                paramValid = false;
            }
        }

        if (!paramValid) {

            isValid = false;

            $param.addClass('validation-error');
            $section.addClass('section-error');

            if (!firstError) firstError = $section;
        }

    });

    // otevři sekci kde je chyba
    if (!isValid && firstError) {

        if (!firstError.hasClass('openGroup')) {
            firstError.addClass('openGroup');
            firstError.find('.custom-surcharge-group').addClass('open');
        }

        $('html, body').animate({
            scrollTop: firstError.offset().top - 120
        }, 400);
    }

    return isValid;
}

function clearValidationState($param){

    const $section = $param.closest('.surcharge-section');

    // zkontroluj jestli už je parametr validní
    let paramValid = true;

    const $options = $param.find('.surcharge');
    if ($options.length && $options.filter('.active').length === 0) {
        paramValid = false;
    }

    const $textarea = $param.find('textarea');
    if ($textarea.length && $textarea.val().trim() === '') {
        paramValid = false;
    }

    const $file = $param.find('input[type="file"]');
    if ($file.length && !$file.val()) {
        paramValid = false;
    }

    if (paramValid) {
        $param.removeClass('validation-error');
    }

    // pokud už v sekci není žádná chyba → smaž i section-error
    if ($section.find('.validation-error').length === 0) {
        $section.removeClass('section-error');
    }
}



$('body').on('click', '.add-to-cart button', function(e){

    if (!validateProductTree()) {
        e.preventDefault();
        e.stopImmediatePropagation();

        alert('Prosím vyplňte všechny povinné parametry.');
        return false;
    }

});